<template>
	<transition name="modal-fade">
		<div class="modal-bg">
			<div aria-describedby="modalDescription" aria-labelledby="modalTitle" class="modal" role="dialog">
				<header class="modal-header" id="modalTitle">
					<slot name="header">
						This is the default title!
					</slot>
					<a @click="close" aria-label="Close modal" class="modal-close" title="Close modal"><i class="fas fa-times"></i></a>
				</header>
				<section class="modal-body" id="modalDescription">
					<slot name="body">
						I'm the default body!
					</slot>
				</section>
				<footer class="modal-footer">
					<slot name="footer">
						I'm the default footer!
					</slot>
				</footer>
			</div>
		</div>
	</transition>
</template>

<script>
    export default {
        name: "NewModal",

        methods: {
            close() {
                this.$emit('close');
            },
        },
    }
</script>

<style scoped>
	.modal-fade-enter,
	.modal-fade-leave-active {
		opacity: 0;
	}

	.modal-fade-enter-active,
	.modal-fade-leave-active {
		transition: opacity .5s ease;
	}
</style>
